import api from "../api";

const api_type = 'v1'

export const GetSpendSummary = params => { return api.post(api_type+`/spend/summary`, params) }
export const GetSpendChannelSummary = params => { return api.post(api_type+`/spend/channel_summary`, params) }
export const GetSpendCheck = params => { return api.post(api_type+`/spend/check`, params) }
export const GetSpendChannelDate = params => { return api.post(api_type+`/spend/channel_date`, params) }
export const GetSpendChannel = params => { return api.post(api_type+`/spend/channel`, params) }
export const GetSpendCountry = params => { return api.post(api_type+`/spend/country`, params) }
export const GetSpendAnalysis = params => { return api.post(api_type+`/spend/analysis`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/spend_api.js